export const getVariantFromOptions = <TVariant extends { options: string[] }>(
  options: string[],
  variants: TVariant[],
): TVariant | undefined =>
  variants.find((variant) =>
    variant.options.every((option, index) => option === options[index]),
  )
